import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';

import App from './components/App';

import './assets/styles/global.less';
import 'office-ui-fabric-react/dist/css/fabric.min.css';

// Office intentionally breaks history.replaceState. See https://stackoverflow.com/questions/42642863/office-js-nullifies-browser-history-functions-breaking-history-usage/42703406#42703406
// How rude!
// keycloak.js depends on history.replaceState.
// Soooo....  we polyfill it back in.
import 'html5-history-api/history.js';
// Isn't web programming fun?

initializeIcons();

let isOfficeInitialized = false;

const title = 'Approved Language';

const render = (Component) => {
    ReactDOM.render(
        <AppContainer>
            <Fabric>
            <Component title={title} isOfficeInitialized={isOfficeInitialized} />
            </Fabric>
        </AppContainer>,
        document.getElementById('container')
    );
};

// Office.onReady(function(){
//     isOfficeInitialized = true;
//     render(App);    
// });

/* Render application after Office initializes */
Office.initialize = () => {
    isOfficeInitialized = true;    
    render(App);
};


/* Initial render showing a progress bar */
render(App);

if ((module as any).hot) {
    (module as any).hot.accept('./components/App', () => {
        const NextApp = require('./components/App').default;
        render(NextApp);
    });
}



// WEBPACK FOOTER //
// ./index.tsx